import React, { useState, useEffect } from 'react';
import { Button } from 'antd'
import { CiMobile2 } from "react-icons/ci";
import { IoMdMail } from "react-icons/io";
import { BsFillTelephoneFill } from "react-icons/bs";
import { FaFacebookF, FaTwitter } from "react-icons/fa";
import { IoIosArrowUp } from "react-icons/io";
import { allPaths } from '../../utils/constants'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
const MainFooter = (props) => {
    const { user, authActions, selectedLanguage } = props
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const history = useHistory()
    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };


    const logout = () => {
        authActions?.removeUser()
        history.push(allPaths?.HOME)
    }

    return (
        <div className="footer-main">
            <div className="footer-1">
                <div className="footer-box-1">
                    <div className="footer-text-heading">
                        <h2>
                            {selectedLanguage?.txt_cairo_clinic}
                        </h2>
                        <p>
                            {selectedLanguage?.txt_15B}
                            <br />
                            {selectedLanguage?.txt_street}
                            <br />
                            {selectedLanguage?.txt_zamalek_cairo}
                        </p>
                        <p className="footer-no-text">
                            <CiMobile2 className="mbl-icon" /> +20 100 664 4922
                        </p>
                    </div>
                </div>
                <div className="footer-box-2">
                    <div className="footer-text-heading">
                        <h2>
                            {selectedLanguage?.txt_hurghada_clinic}
                        </h2>
                        <p>
                            {selectedLanguage?.txt_sheraton_road}
                            <br />
                            {selectedLanguage?.txt_hurghada_red_sea}
                        </p>
                        <p className="footer-no-text">
                            <CiMobile2 className="mbl-icon" /> +20 114 551 4733
                        </p>
                        <p className="footer-no-text">
                            <BsFillTelephoneFill className="mbl-icon" /> +20 653 447 890
                        </p>
                    </div>
                </div>
                <div className="footer-box-3">
                    <div className="footer-text-heading">
                        <h2>
                            {selectedLanguage?.txt_office_hours}
                        </h2>
                        <p>
                            {selectedLanguage?.txt_first_timing}
                        </p>
                        <p>
                            {selectedLanguage?.txt_second_timing}
                        </p>
                        <p>
                            {selectedLanguage?.txt_friday_off}
                        </p>
                    </div>
                </div>
                <div className="footer-box-4">
                    <div className="footer-text-heading">
                        <h2>
                            {selectedLanguage?.txt_contact_us}
                        </h2>
                        <p className="footer-no-text">
                            <IoMdMail className="mbl-icon" /> info@primadent-hrg.com
                        </p>
                        {user?._id && <p className="footer-no-text">
                            <a onClick={()=> history?.push(allPaths?.CONTACT_DATA)}>{selectedLanguage?.txt_contact_data}</a>
                        </p>}
                    </div>
                </div>
            </div>
            <div>
                <div className="header-1 footer-2">
                    <div className="header-1-inner-div footer-inner-div">
                        <div className="header-text-div">
                            <p className="header-text footer-2-text">
                                <span>{selectedLanguage?.txt_primadent_dental_care}</span> {selectedLanguage?.txt_all_rights_reserved} {currentYear}, {selectedLanguage?.txt_powered_by_your_company}
                                <a className="header-text-link footer-text-link" href="">{selectedLanguage?.txt_innovix_solution}</a>
                            </p>
                        </div>
                        <div className="header-social-icons-div footer-social-icons-div">
                            <button className="social-icons-button footer-social-icons"><FaFacebookF className="social-icons" /></button>
                            <button className="social-icons-button footer-social-icons"><FaTwitter className="social-icons" /></button>
                            <div className="up-arrow-icon-div" onClick={handleScrollToTop}>
                                <IoIosArrowUp />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', background: '#002c3c',marginTop:'-150px',marginRight:'10px' }}>
                {user?._id ?
                    <Button
                        onClick={logout}
                    >{selectedLanguage?.txt_logout}</Button> :
                    <Button
                        onClick={() => history.push(allPaths?.LOGIN)}
                    >{selectedLanguage?.txt_login}</Button>
                }
            </div>
        </div>
    )
}

export default MainFooter